import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=557f7f82&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557f7f82')) {
      api.createRecord('557f7f82', component.options)
    } else {
      api.reload('557f7f82', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=557f7f82&", function () {
      api.rerender('557f7f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ga8o4zVvNt5H/JS/cancellationPolicy.vue"
export default component.exports